










































































































import cloneDeep from 'lodash/cloneDeep';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'

import DepartmentForm from './DepartmentForm/DepartmentForm.vue';
import uniq from 'lodash/uniq';
import moment from 'moment';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'exportData'
    ])
  },
  components: {
    TitleBar
  }
})
export default class DepartmentsManager extends Vue {

get titleStack () {
    return [
      'Компания', 'Структура'
    ]
  }

  get opened() {
    // @ts-ignore
    return this.documents.map((doc: any) => doc.id)
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null
  }

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }
  private delayFilter: any = null

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query, ...filter
          }
        })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  // ---------------------------------------------------------------------------

  openBaseDepartment(row: any) {
    this.$buefy.modal.open({
      component: DepartmentForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {
          parent_id: 'd:departments:22'
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  openDepartment(row: any, parentDepartment: any) {
    this.$buefy.modal.open({
      component: DepartmentForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: parentDepartment ? {
          parent_id: parentDepartment.id
        } : {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // this.checkFilterChange();
    this.handleParamsChange();
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
